'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import type { TopNavV5Tile as TopNavV5TileType } from '@src/components/TopNavV5/TopNavV5Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavV5Tile = props => {
  const $ = _c(18);
  const {
    tile
  } = props;
  const trackSelectNavCta = useTrackSelectNavCta();
  const t0 = tile?.newTab ? "noopener noreferrer" : "";
  const t1 = tile?.newTab ? "_blank" : "_self";
  const t2 = tile?.href ?? "";
  let t3;
  if ($[0] !== tile?.href || $[1] !== trackSelectNavCta) {
    t3 = () => {
      trackSelectNavCta({
        "cta url": tile?.href
      });
    };
    $[0] = tile?.href;
    $[1] = trackSelectNavCta;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = tile?.image ?? "";
  const t5 = tile?.alt ?? "";
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = <div className="relative mb-2 aspect-3/2 w-full overflow-hidden rounded-[30px] bg-bodi-gray-medium"><Image className="object-cover" src={t4} alt={t5} fill={true} /></div>;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== tile) {
    t7 = tile?.stamp && <div className="w-fit text-bodi-accent-bright-500">{tile.stamp}</div>;
    $[6] = tile;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = tile?.title;
  let t9;
  if ($[8] !== t8) {
    t9 = <div className="w-fit text-white">{t8}</div>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t10 = <LocalizedLink rel={t0} target={t1} href={t2} className="w-full font-medium" onClick={t3}>{t6}{t7}{t9}</LocalizedLink>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};